import { css } from 'styled-components';
import { border } from 'styled-system';
import { Flex } from '@goodrx/matisse-react';
import { createComponent } from '../../utils';
export const BorderedFlex = createComponent({
  name: 'Flex',
  as: Flex,
  style: () => css`
    ${border}
  `
});
BorderedFlex.displayName = 'BorderedFlex';